// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".close[data-v-0985261c]{top:10px;right:10px;padding:0;position:absolute}.cert[data-v-0985261c]{position:relative}.cert .secret-name[data-v-0985261c]{height:61px}.cert[data-v-0985261c]:not(:last-of-type){padding-bottom:10px;margin-bottom:30px}", ""]);
// Exports
module.exports = exports;
